// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RelayRuntime = require("relay-runtime");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");
let ConversationPageConversationMessagesRefetchQuery_graphql = require("./ConversationPageConversationMessagesRefetchQuery_graphql.bs.js");

let Types = {};

function unwrap_fragment_conversationTimeline_edges_node_BuyerNeedBroadcast_content(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["BuyerNeedV5"]);
}

function unwrap_fragment_conversationTimeline_edges_node_ConversationMessageV5_status(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["IncomingMessageStatus"]);
}

function unwrap_fragment_conversationTimeline_edges_node_ForSalePropertyBroadcast_content(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ForSalePropertyV5"]);
}

function unwrap_fragment_conversationTimeline_edges_node_RentalNeedBroadcast_content(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["RentalNeedV5"]);
}

function unwrap_fragment_conversationTimeline_edges_node_RentalPropertyBroadcast_content(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["RentalPropertyV5"]);
}

function unwrap_fragment_conversationTimeline_edges_node(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "BuyerNeedBroadcast",
    "ConversationMessageV5",
    "ForSalePropertyBroadcast",
    "RentalNeedBroadcast",
    "RentalPropertyBroadcast"
  ]);
}

let fragmentConverter = {"__root":{"conversationTimeline_edges_node_RentalPropertyBroadcast_content":{"u":"fragment_conversationTimeline_edges_node_RentalPropertyBroadcast_content"},"conversationTimeline_edges_node_RentalPropertyBroadcast_broadcastAt":{"b":""},"conversationTimeline_edges_node_RentalNeedBroadcast_content":{"u":"fragment_conversationTimeline_edges_node_RentalNeedBroadcast_content"},"conversationTimeline_edges_node_RentalNeedBroadcast_broadcastAt":{"b":""},"conversationTimeline_edges_node_ForSalePropertyBroadcast_content":{"u":"fragment_conversationTimeline_edges_node_ForSalePropertyBroadcast_content"},"conversationTimeline_edges_node_ForSalePropertyBroadcast_broadcastAt":{"b":""},"conversationTimeline_edges_node_ConversationMessageV5_status":{"u":"fragment_conversationTimeline_edges_node_ConversationMessageV5_status"},"conversationTimeline_edges_node_ConversationMessageV5_sentAt":{"b":""},"conversationTimeline_edges_node_ConversationMessageV5":{"f":""},"conversationTimeline_edges_node_BuyerNeedBroadcast_content":{"u":"fragment_conversationTimeline_edges_node_BuyerNeedBroadcast_content"},"conversationTimeline_edges_node_BuyerNeedBroadcast_broadcastAt":{"b":""},"conversationTimeline_edges_node":{"u":"fragment_conversationTimeline_edges_node"},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_conversationTimeline_edges_node_BuyerNeedBroadcast_content: unwrap_fragment_conversationTimeline_edges_node_BuyerNeedBroadcast_content,
  fragment_conversationTimeline_edges_node_ConversationMessageV5_status: unwrap_fragment_conversationTimeline_edges_node_ConversationMessageV5_status,
  fragment_conversationTimeline_edges_node_ForSalePropertyBroadcast_content: unwrap_fragment_conversationTimeline_edges_node_ForSalePropertyBroadcast_content,
  fragment_conversationTimeline_edges_node_RentalNeedBroadcast_content: unwrap_fragment_conversationTimeline_edges_node_RentalNeedBroadcast_content,
  fragment_conversationTimeline_edges_node_RentalPropertyBroadcast_content: unwrap_fragment_conversationTimeline_edges_node_RentalPropertyBroadcast_content,
  fragment_conversationTimeline_edges_node: unwrap_fragment_conversationTimeline_edges_node
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function makeConnectionId(connectionParentDataId) {
  return RelayRuntime.ConnectionHandler.getConnectionID(connectionParentDataId, "ConversationPageConversationMessages_conversation_conversationTimeline", undefined);
}

function getConnectionNodes(connection) {
  if (connection !== undefined) {
    return Stdlib_Array.filterMap(connection.edges, edge => {
      if (edge !== undefined) {
        return edge.node;
      }
    });
  } else {
    return [];
  }
}

function incomingMessageStatusState_decode($$enum) {
  if ($$enum === "NEW" || $$enum === "READ" || $$enum === "PAST_MESSAGE") {
    return $$enum;
  }
}

let incomingMessageStatusState_fromString = incomingMessageStatusState_decode;

let Utils = {
  getConnectionNodes: getConnectionNodes,
  incomingMessageStatusState_decode: incomingMessageStatusState_decode,
  incomingMessageStatusState_fromString: incomingMessageStatusState_fromString
};

function makeNode(rescript_graphql_node_ConversationPageConversationMessagesRefetchQuery) {
  return ((function(){
var v0 = [
  "conversationTimeline"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  (v1/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "broadcastAt",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 500,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": rescript_graphql_node_ConversationPageConversationMessagesRefetchQuery,
      "identifierInfo": {
        "identifierField": "nodeId",
        "identifierQueryVariableName": "nodeId"
      }
    }
  },
  "name": "ConversationPageConversationMessages_conversation",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConversationPageConversationMessagesMessage_conversation"
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nodeId",
      "storageKey": null
    },
    {
      "alias": "conversationTimeline",
      "args": null,
      "concreteType": "ConversationTimelineConnection",
      "kind": "LinkedField",
      "name": "__ConversationPageConversationMessages_conversation_conversationTimeline_connection",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "ConversationTimelineItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v3/*: any*/),
                            "type": "BuyerNeedV5",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v1/*: any*/)
                    ],
                    "type": "BuyerNeedBroadcast",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v3/*: any*/),
                            "type": "ForSalePropertyV5",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v1/*: any*/)
                    ],
                    "type": "ForSalePropertyBroadcast",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v3/*: any*/),
                            "type": "RentalNeedV5",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v1/*: any*/)
                    ],
                    "type": "RentalNeedBroadcast",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v3/*: any*/),
                            "type": "RentalPropertyV5",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v1/*: any*/)
                    ],
                    "type": "RentalPropertyBroadcast",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sentAt",
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ConversationPageConversationMessagesMessage_message"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "state",
                                  "storageKey": null
                                },
                                "action": "NONE"
                              }
                            ],
                            "type": "IncomingMessageStatus",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ConversationMessageV5",
                    "abstractKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          "action": "THROW"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "ConversationV5",
  "abstractKey": null
};
})());
}

let node = makeNode(ConversationPageConversationMessagesRefetchQuery_graphql.node);

let wrap_fragment_conversationTimeline_edges_node_BuyerNeedBroadcast_content = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_conversationTimeline_edges_node_ConversationMessageV5_status = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_conversationTimeline_edges_node_ForSalePropertyBroadcast_content = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_conversationTimeline_edges_node_RentalNeedBroadcast_content = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_conversationTimeline_edges_node_RentalPropertyBroadcast_content = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_conversationTimeline_edges_node = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_conversationTimeline_edges_node_BuyerNeedBroadcast_content = unwrap_fragment_conversationTimeline_edges_node_BuyerNeedBroadcast_content;
exports.wrap_fragment_conversationTimeline_edges_node_BuyerNeedBroadcast_content = wrap_fragment_conversationTimeline_edges_node_BuyerNeedBroadcast_content;
exports.unwrap_fragment_conversationTimeline_edges_node_ConversationMessageV5_status = unwrap_fragment_conversationTimeline_edges_node_ConversationMessageV5_status;
exports.wrap_fragment_conversationTimeline_edges_node_ConversationMessageV5_status = wrap_fragment_conversationTimeline_edges_node_ConversationMessageV5_status;
exports.unwrap_fragment_conversationTimeline_edges_node_ForSalePropertyBroadcast_content = unwrap_fragment_conversationTimeline_edges_node_ForSalePropertyBroadcast_content;
exports.wrap_fragment_conversationTimeline_edges_node_ForSalePropertyBroadcast_content = wrap_fragment_conversationTimeline_edges_node_ForSalePropertyBroadcast_content;
exports.unwrap_fragment_conversationTimeline_edges_node_RentalNeedBroadcast_content = unwrap_fragment_conversationTimeline_edges_node_RentalNeedBroadcast_content;
exports.wrap_fragment_conversationTimeline_edges_node_RentalNeedBroadcast_content = wrap_fragment_conversationTimeline_edges_node_RentalNeedBroadcast_content;
exports.unwrap_fragment_conversationTimeline_edges_node_RentalPropertyBroadcast_content = unwrap_fragment_conversationTimeline_edges_node_RentalPropertyBroadcast_content;
exports.wrap_fragment_conversationTimeline_edges_node_RentalPropertyBroadcast_content = wrap_fragment_conversationTimeline_edges_node_RentalPropertyBroadcast_content;
exports.unwrap_fragment_conversationTimeline_edges_node = unwrap_fragment_conversationTimeline_edges_node;
exports.wrap_fragment_conversationTimeline_edges_node = wrap_fragment_conversationTimeline_edges_node;
exports.Internal = Internal;
exports.makeConnectionId = makeConnectionId;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
